import { RootState } from '../reducers'

export const getWaitOverlayVisible = (name: string) => (state: RootState) =>
  (state.waitOverlays[name] && state.waitOverlays[name].visible) || false
export const getWaitOverlayExists = (name: string) => (state: RootState) =>
  state.waitOverlays[name] !== undefined
